import { defineMessages } from 'react-intl';

export default defineMessages({
	amountDescription: {
		id: 'pages.walletPayment.FactorAmount.amountDescription',
		defaultMessage: 'مبلغ فاکتور مشتری را وارد کنید',
	},
	buttonLabel: {
		id: 'pages.walletPayment.FactorAmount.buttonLabel',
		defaultMessage: 'مرحله بعد',
	},
});
